import Vue from 'vue';
//import Vuetify from 'vuetify/lib/framework';
import Vuetify from 'vuetify';

import 'leaflet/dist/leaflet.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@mdi/font/css/materialdesignicons.css';
Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    //iconfont: 'md',
    iconfont: 'mdiSvg',
  },
  theme: {
    themes: {
      light: {
        primary: '#4d7d33',
        secondary: '#4d7d33',
        accent: '#8c9eff',
        error: '#b71c1c',
      },
    },
  },
});

/*import '@mdi/font/css/materialdesignicons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'vuetify/lib/styles/main.sass'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/lib/components'
import * as directives from 'vuetify/lib/directives'

export default createVuetify({
  components,
  directives,
  iconfont: 'fa',
})

*/